export default __webpack_public_path__ + "static/media/website_background.5988c520.mov";